// Tasks & chain-of-command routes
//
// A single page hosts the org-chart tree, the task board, and the
// assign/detail dialogs. Gated behind the "tasks" app permission; appadmin
// (the CEO) bypasses app gating in the global router guard.

const tasksRoutes = [
  {
    path: "/tasks",
    name: "TasksHome",
    component: () => import("@/views/tasks/TasksHome.vue"),
    meta: { requiresAuth: true, app: "tasks", feature: "tasks" },
  },
];

export default tasksRoutes;
